import { ShippingCosts } from "./ShippingCosts"
import { FulfillmentDate } from "./ShippingTime"

export type ShippingInfoProps = {
  freeShipping: boolean | undefined
  fulfillmentFrom: string | undefined
}

export const ShippingInfo = ({ freeShipping, fulfillmentFrom }: ShippingInfoProps) => {
  return (
    <div className="flex flex-col items-center">
      <ShippingCosts freeShipping={freeShipping} />
      <FulfillmentDate date={fulfillmentFrom} showIcon />
    </div>
  )
}
